/*jslint bitwise: true */
import $ from 'static/script/libs/jquery';
import breakpoints from 'static/script/utils/breakpoints';
import defineComponent from 'flight';
import Spinner from 'static/script/libs/spin';
import isHybridApp from 'static/script/utils/is-hybrid-app';

function Loading() {
    this.defaultAttrs({
        delayInMilliseconds: 1000,
        timeoutId: -1,
        forced: false
    });

    this._spinner = (function() {
        let currentSpinner = null;
        let stop = function() {
            if (!currentSpinner) {
                return;
            }
            currentSpinner.stop();
            currentSpinner = null;
        };
        let start = function() {
            if (currentSpinner) {
                stop();
            }

            let options = {
                top: parseInt(
                    $(window).scrollTop() + $(window).height() / 7 * 3 || 0,
                    10
                ),
                lines: 9,
                length: 8,
                width: 4,
                radius: 6,
                className: 'framed-spinner'
            };

            currentSpinner = new Spinner(options);
            currentSpinner.spin(document.body);
        };
        return {
            start: start,
            stop: stop
        };
    })();

    this._show = function(evt, payload) {
        if (breakpoints.isVisible(breakpoints.xlarge) || isHybridApp()) {
            return;
        }

        if (
            payload &&
            payload.hasOwnProperty('forceStart') &&
            payload.forceStart === true
        ) {
            this.attr.forced = true;
        }

        this._spinner.start();
        this.attr.timeoutId = -1;
    };

    this._startDelay = function() {
        if (this.attr.forced !== true) {
            this._hide();
            this.attr.timeoutId = window.setTimeout(
                this._show.bind(this),
                this.attr.delayInMilliseconds
            );
        }
    };

    this._hide = function() {
        if (this.attr.timeoutId !== -1) {
            window.clearTimeout(this.attr.timeoutId);
            this.attr.timeoutId = -1;
        }

        this.attr.forced = false;
        this._spinner.stop();
    };

    this.after('initialize', function() {
        this.on(document, 'ui:loading:before-load', this._show);
        this.on(document, 'ui:loading:after-load', this._hide);

        this.on(document, 'ui:side-menu:on-filter-click', this._show);
        this.on(document, 'data:navigation-filter:before-load', this._show);
        this.on(document, 'data:navigation-filter:after-load', this._hide);
        this.on(document, 'data:navigation:before-page-load', this._startDelay);
        this.on(document, 'data:navigation-filter:after-load', this._hide);
        this.on(document, 'data:navigation:after-page-load', this._hide);
        this.on(document, 'ui:site-search:on-search-field-input', this._hide);
        this.on(document, 'ui:price-check:before-check', this._show);
        this.on(document, 'ui:price-check:after-check', this._hide);
    });
}

export default defineComponent.component(Loading);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/loading.js